import { useState, useCallback } from "react";
import { debounce } from "lodash";
import useGet from "../read/useGet";

const useGetColleagues = (initialSearchQuery = "", initialLimit = 10, initialPageNo = 1) => {
  const [searchQuery, setSearchQuery] = useState(initialSearchQuery);
  const [limit, setLimit] = useState(initialLimit);
  const [pageNo, setPageNo] = useState(initialPageNo);
  const [colleagues, setColleagues] = useState([]);
  
  const { list, paramsObject, setGetListParams } = useGet({
    url: "chat/company-employee-list",
    initialData: {
      searchQuery,
      limit,
      pageNo
    },
    isChat: true, 
    onSuccess: (data) => {
      if (data?.data) {
        // If it's the first page, replace colleagues
        // If it's a subsequent page, append new colleagues
        if (pageNo === 1) {
          setColleagues(data.data);
        } else {
          setColleagues(prev => [...prev, ...data.data]);
        }
      }
    }
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSearch = useCallback(
    debounce((query) => {
      setPageNo(1);
      setColleagues([]); 
      setGetListParams({
        ...paramsObject,
        searchQuery: query,
        pageNo: 1,
      });
    }, 500),
    [paramsObject]
  );

  const updateSearchQuery = (query) => {
    setSearchQuery(query);
    debouncedSearch(query);
  };

  const loadMoreData = () => {
    if (list.data?.pagination?.hasMorePages) {
      const nextPage = pageNo + 1;
      setPageNo(nextPage);
      setGetListParams({
        ...paramsObject,
        pageNo: nextPage,
      });
    }
  };

  return {
    colleagues: colleagues,
    loading: list.isLoading,
    isFetching: list.isFetching, 
    error: list.error,
    pagination: list.data?.pagination,
    updateSearchQuery,
    loadMoreData,
    refetch: list.refetch
  };
};

export default useGetColleagues;
